module.exports = __webpack_public_path__ + "static/media/Twitter.1fd81f6b.svg";